module.exports = __webpack_public_path__ + "img/26.180e7227.png";